<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  page: {
    type: Number,
    required: true,
  },
  size: {
    type: Number,
    required: true,
  },
  pages: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['more'])
const previous = ref([])
const current = toRef(props, 'items')
const next = ref([])
next.value = getNext(props.items, props.page)

function getNext(items, page) {
  const data = items.slice(
    page * props.size,
    Math.min(page * props.size + 3, props.total),
  )
  return data
}

function loadNext(page) {
  emit('more', page)
}
</script>

<template>
  <LoadMore
    :name="name"
    :page="page"
    :size="size"
    :pages="pages"
    :loading="loading"
    :total="total"
    @next="loadNext"
  >
    <template #previous>
      <div class="grid">
        <ProductTeaserDetail
          v-for="(item, index) in previous"
          :key="index"
          :slide="item"
          class="grid__item"
          parent-type="search"
        />
      </div>
    </template>
    <template #default>
      <div
        class="grid"
        :class="{
          'grid--previous': previous.length > 0,
          'grid--next': next.length > 0,
        }"
      >
        <ProductTeaserDetail
          v-for="(item, index) in current"
          :key="index"
          :slide="item"
          class="item"
          parent-type="search"
        />
      </div>
    </template>
    <template #next>
      <div class="grid">
        <ProductTeaserDetail
          v-for="(item, index) in next"
          :key="index"
          :slide="item"
          class="grid__item"
          parent-type="search"
        />
      </div>
    </template>
  </LoadMore>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 40px;
  row-gap: clamp(20px, 1.39vw + 15.56px, 40px);
  margin: 0;

  @include media-breakpoint-down(640) {
    grid-template-columns: 1fr;
  }

  &--previous {
    margin-top: 30px;
  }

  &--next {
    margin-bottom: 30px;
  }

  &__item {
    width: 100%;
  }
}
</style>
